import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

export const useSentryScope = ({
  isAuthenticated,
  identity,
  orgName,
  region,
}: {
  isAuthenticated: boolean;
  identity?: string;
  orgName?: string;
  region?: string;
}) => {
  useEffect(() => {
    if (isAuthenticated && identity) {
      Sentry.setUser({ id: identity });
      Sentry.setTag('organization', orgName);
      Sentry.setTag('region', region);
    } else {
      Sentry.setUser(null);
    }
  }, [isAuthenticated, identity, orgName, region]);
};
